import { createStyles } from '@mantine/core'

export const useStyles = createStyles((theme) => ({
	authButton: {},
	btn: {
		color: theme.black,
		fontWeight: 400,
	},
}))
